document.addEventListener('click', function (e) {
    const btn = e.target.closest('.apt-footer-newsletter__trigger');
    if (!btn) return;
    const id = btn.getAttribute('data-reveal');
    const panel = document.getElementById(id);
    if (!panel) return;
    const collapsed = panel.classList.contains('is-collapsed');
    if (collapsed) {
        panel.classList.remove('is-collapsed');
        panel.removeAttribute('data-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        // focus input after animation
        setTimeout(() => { const input = panel.querySelector('input[type="email"]'); if (input) input.focus(); }, 260);
    } else {
        panel.classList.add('is-collapsed');
        panel.setAttribute('data-collapsed', '');
        btn.setAttribute('aria-expanded', 'false');
    }
});
